import { render, staticRenderFns } from "./gerar-receita-excel.vue?vue&type=template&id=2a3c5ebb&scoped=true&"
import script from "./gerar-receita-excel.vue?vue&type=script&lang=js&"
export * from "./gerar-receita-excel.vue?vue&type=script&lang=js&"
import style0 from "./gerar-receita-excel.vue?vue&type=style&index=0&id=2a3c5ebb&lang=scss&scoped=true&"
import style1 from "./gerar-receita-excel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c5ebb",
  null
  
)

export default component.exports